import { useState } from 'react';
import { Key, Shield } from 'lucide-react';
import axios from 'axios';
import DebitoInmediatoTesting from '@/components/DebitoInmediatoTesting';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function CredentialsTab({ credentials, onReload, setToast }) {
  const [editingCredential, setEditingCredential] = useState({ key: '', value: '' });

  const handleUpdateCredential = async (key, value) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${BACKEND_URL}/api/super-admin/credentials/${key}`, null, {
        headers: { Authorization: `Bearer ${token}` },
        params: { value, encrypt: true }
      });
      setToast({ type: 'success', message: 'Credencial actualizada correctamente' });
      setEditingCredential({ key: '', value: '' });
      onReload();
    } catch (error) {
      setToast({ type: 'error', message: 'Error al actualizar credencial' });
    }
  };

  return (
    <div data-testid="credentials-tab">
      <h2 className="text-2xl font-bold mb-6" style={{ color: '#051C2C' }}>
        Credenciales de Servicios Integrados
      </h2>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <p className="text-sm text-blue-900 font-medium">Gestion de credenciales de APIs externas</p>
        <p className="text-sm text-blue-800 mt-1">Estas credenciales se guardan encriptadas y se usan para todas las operaciones del sistema.</p>
      </div>

      {credentials ? (
        <div className="space-y-6">
          <div className="bg-white rounded-xl p-6 border">
            <h3 className="font-bold text-lg mb-4" style={{ color: '#003594' }}>Banco Plaza API</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">API Key</label>
                <div className="flex gap-2">
                  <input type="password" value={credentials.banco_plaza_api_key || 'No configurado'} readOnly className="flex-1 px-4 py-2 border rounded-lg bg-gray-50" />
                  <button onClick={() => setEditingCredential({ key: 'banco_plaza_api_key', value: '', label: 'Banco Plaza API Key' })} className="px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Editar</button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">API Secret</label>
                <div className="flex gap-2">
                  <input type="password" value={credentials.banco_plaza_api_secret || 'No configurado'} readOnly className="flex-1 px-4 py-2 border rounded-lg bg-gray-50" />
                  <button onClick={() => setEditingCredential({ key: 'banco_plaza_api_secret', value: '', label: 'Banco Plaza API Secret' })} className="px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Editar</button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Ambiente</label>
                <select value={credentials.banco_plaza_environment || 'test'} onChange={(e) => handleUpdateCredential('banco_plaza_environment', e.target.value)} className="w-full px-4 py-2 border rounded-lg">
                  <option value="test">Test/QA</option>
                  <option value="production">Produccion</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border">
            <h3 className="font-bold text-lg mb-4" style={{ color: '#003594' }}>Stripe</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">API Key</label>
              <div className="flex gap-2">
                <input type="password" value={credentials.stripe_api_key || 'No configurado'} readOnly className="flex-1 px-4 py-2 border rounded-lg bg-gray-50" />
                <button onClick={() => setEditingCredential({ key: 'stripe_api_key', value: '', label: 'Stripe API Key' })} className="px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Editar</button>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border">
            <h3 className="font-bold text-lg mb-4" style={{ color: '#003594' }}>PayPal</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Client ID</label>
                <div className="flex gap-2">
                  <input type="password" value={credentials.paypal_client_id || 'No configurado'} readOnly className="flex-1 px-4 py-2 border rounded-lg bg-gray-50" />
                  <button onClick={() => setEditingCredential({ key: 'paypal_client_id', value: '', label: 'PayPal Client ID' })} className="px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Editar</button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Secret</label>
                <div className="flex gap-2">
                  <input type="password" value={credentials.paypal_secret || 'No configurado'} readOnly className="flex-1 px-4 py-2 border rounded-lg bg-gray-50" />
                  <button onClick={() => setEditingCredential({ key: 'paypal_secret', value: '', label: 'PayPal Secret' })} className="px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Editar</button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <DebitoInmediatoTesting />
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl p-12 text-center border">
          <Key className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-gray-600">Cargando credenciales...</p>
        </div>
      )}

      {/* Edit Credential Modal */}
      {editingCredential.key && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="p-6 border-b">
              <h2 className="text-xl font-bold" style={{ color: '#051C2C' }}>Actualizar Credencial</h2>
              <p className="text-sm text-gray-600 mt-1">{editingCredential.label || editingCredential.key}</p>
            </div>
            <div className="p-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Nuevo Valor</label>
              <input type="text" value={editingCredential.value} onChange={(e) => setEditingCredential({ ...editingCredential, value: e.target.value })} className="w-full px-4 py-2 border rounded-lg" placeholder="Ingresa el nuevo valor" />
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-4">
                <p className="text-xs text-yellow-800">Esta credencial sera encriptada antes de guardarse.</p>
              </div>
            </div>
            <div className="p-6 border-t flex gap-3">
              <button onClick={() => setEditingCredential({ key: '', value: '' })} className="flex-1 px-4 py-2 border rounded-lg hover:bg-gray-50">Cancelar</button>
              <button onClick={() => { handleUpdateCredential(editingCredential.key, editingCredential.value); }} className="flex-1 px-4 py-2 text-white rounded-lg" style={{ backgroundColor: '#003594' }}>Actualizar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
